import { useTickSoundInteraction } from '@/hooks';
import { useTranslation } from 'react-i18next';

export default function BranchNotice() {
    const { t } = useTranslation();
    const { playTick } = useTickSoundInteraction();
    const titleLead = t('parking.branchNotice.titleLead');
    const titleRest = t('parking.branchNotice.titleRest');
    const bullet1 = t('parking.branchNotice.bullet1');
    const bullet2 = t('parking.branchNotice.bullet2');

    return (
        <div
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    playTick();
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
            data-region-nav
            data-region-order={2}
            tabIndex={2}
            data-interactive
            aria-label={`${titleLead} ${titleRest} ${bullet1} ${bullet2}`}
            className="focus-border contrast:bg-transparent fullscreen:w-full flex w-[calc(360*var(--vw-unit))] shrink-0 flex-col items-center gap-[calc(12*var(--vh-unit))] rounded-[calc(16*var(--vh-unit))] bg-[var(--color-black-eaeaea)] p-[calc(20*var(--vh-unit))] text-center"
        >
            <p className="fullscreen:text-[calc(24*var(--vh-unit))] fullscreen:leading-[calc(32*var(--vh-unit))] text-[calc(20*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-bold tracking-[calc(-0.4*var(--vh-unit))] text-[#C43739] contrast:text-[color:var(--color-text-black)]">
                {titleLead}
                <br className="fullscreen:hidden" />
                <span className="fullscreen:inline hidden"> </span>
                {titleRest}
            </p>
            <ul className="marker:text-[color:var(--color-text-sub01)] fullscreen:text-[calc(18*var(--vh-unit))] fullscreen:leading-[calc(24*var(--vh-unit))] w-full list-inside list-disc text-center text-[calc(14*var(--vh-unit))] leading-[calc(18*var(--vh-unit))] font-[400] text-[color:var(--color-text-sub01)] fullscreen:font-[500]">
                <li>{bullet1}</li>
                <li>{bullet2}</li>
            </ul>
        </div>
    );
}
